// extracted by mini-css-extract-plugin
export default {"message_container":"ErrorBoundary_message_container__eYWsI","text":"ErrorBoundary_text__fbb7E"};